import { useEffect, useState } from "react";

export default function ProductNavbar() {
  const [active, setActive] = useState("sr-anchor");

  useEffect(() => {
    const sections = [
      "sr-anchor",
      "zk-anchor",
      "bp-anchor",
      "lcg-anchor",
      "ar-anchor",
      "sb-anchor",
      "jr-anchor",
      "rc-anchor",
      "rch-anchor",
    ];

    const handleScroll = () => {
      const viewportCenter = window.innerHeight / 2;
      let closest = { id: null, distance: Infinity };

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          const sectionCenter = rect.top + rect.height / 2;
          const distance = Math.abs(sectionCenter - viewportCenter);

          if (distance < closest.distance) {
            closest = { id, distance };
          }
        }
      });

      if (closest.id) {
        setActive(closest.id);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      // Check if there’s enough space below to allow centering
      const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;
      const targetTop = el.offsetTop - window.innerHeight / 2;

      if (targetTop > maxScrollTop) {
        // Not enough room → use start
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // Enough room → keep the nice centering
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  return (
    <div className="prod-navbar-div">
      <ul>
        <li>
          <button
            className={`sr-button ${active === "sr-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("sr-anchor")}
          >
            <span className="short-label">SR</span>
            <span className="full-label">STRAWBERRY RUNTS</span>
          </button>
          <button
            className={`zk-button ${active === "zk-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("zk-anchor")}
          >
            <span className="short-label">ZK</span>
            <span className="full-label">ZKITTLEZ</span>
          </button>
          <button
            className={`bp-button ${active === "bp-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("bp-anchor")}
          >
            <span className="short-label">BP</span>
            <span className="full-label">BLOWPOPZ</span>
          </button>
          <button
            className={`lcg-button ${active === "lcg-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("lcg-anchor")}
          >
            LCG
          </button>
          <button
            className={`ar-button ${active === "ar-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("ar-anchor")}
          >
            <span className="short-label">AR</span>
            <span className="full-label">APPLES REVENGE</span>
          </button>
          <button
            className={`sb-button ${active === "sb-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("sb-anchor")}
          >
            <span className="short-label">SB</span>
            <span className="full-label">STARBURST</span>
          </button>
          <button
            className={`jr-button ${active === "jr-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("jr-anchor")}
          >
            <span className="short-label">JR</span>
            <span className="full-label">JELLY RANCHER</span>
          </button>
          <button
            className={`rc-button ${active === "rc-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("rc-anchor")}
          >
            <span className="short-label">RC</span>
            <span className="full-label">RAINBOW COOKIES</span>
          </button>
          <button
            className={`rch-button ${active === "rch-anchor" ? "active" : ""}`}
            onClick={() => scrollToSection("rch-anchor")}
          >
            <span className="short-label">RCH</span>
            <span className="full-label">RASPBERRY CHEESECAKE</span>
          </button>
        </li>
      </ul>
    </div>
  );
}
